import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { CompareOnboardingContent } from './CompareOnboardingContent';
import * as styles from './CompareButton.css';

interface ICompareButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  onClose(): void;
}

export function CompareButtonOnboarding({ children, open, onClose }: ICompareButtonOnboardingProps) {
  return (
    <OnboardingTooltip
      theme="black"
      content={<CompareOnboardingContent />}
      placement="left"
      portalElement={typeof document !== 'undefined' ? document.getElementById('offers-layout') : undefined}
      open={open}
      onClose={onClose}
      flip={false}
    >
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
